import { Icon } from '@gitbook/spine-icons';
import { Button, Menu, MenuItem, MenuRoot, MenuTrigger, Popover } from '@gitbook/spine-react';

export function AddContentMenu(props: {
    onPickFiles: () => void;
    onTriggerSlashCommands: () => void;
    uploadsDisabledReason?: string;
}) {
    const { onPickFiles, onTriggerSlashCommands, uploadsDisabledReason } = props;
    return (
        <MenuRoot>
            <MenuTrigger>
                <Button
                    kind="blank"
                    size="small"
                    label="Add content"
                    iconOnly
                    leadingIcon={Icon.Plus}
                />
            </MenuTrigger>
            <Popover restoreFocus={false}>
                <Menu>
                    <MenuItem
                        icon={Icon.Paperclip}
                        onAction={onPickFiles}
                        disabled={Boolean(uploadsDisabledReason)}
                        subtitle={uploadsDisabledReason}
                    >
                        Add files or photos
                    </MenuItem>
                    <MenuItem icon={Icon.Slash} onAction={onTriggerSlashCommands}>
                        Example prompts
                    </MenuItem>
                </Menu>
            </Popover>
        </MenuRoot>
    );
}
